// Etichete prietenoase RO pentru chei tehnice — centralizate ca să fie consistente
// între secțiuni, filtre, drill-down și export.

export const LABELS_CATEGORIE: Record<string, string> = {
  geam_tren: "Geam tren",
  usi: "Uși",
  partitii: "Partiții",
  vagoane: "Vagoane",
  constructii: "Construcții",
};

export function labelCategorie(key: string): string {
  return LABELS_CATEGORIE[key] ?? key;
}

export const LABEL_SEGMENT: Record<string, string> = {
  export: "Export",
  intern: "Intern (RO)",
};

export function labelSegment(key: string): string {
  return LABEL_SEGMENT[key] ?? key;
}
